import { render, staticRenderFns } from "./GarageServices.vue?vue&type=template&id=935f3934&scoped=true"
import script from "./GarageServices.vue?vue&type=script&lang=js"
export * from "./GarageServices.vue?vue&type=script&lang=js"
import style0 from "./GarageServices.vue?vue&type=style&index=0&id=935f3934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935f3934",
  null
  
)

export default component.exports